
import { defineComponent } from "vue";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import ApiService from "@/core/services/ApiService";

import { useToast } from "vue-toastification";
import Switch from "@/components/widgets/custom/Switch.vue";
// Import loading overlay
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

import Pagination from "@/components/widgets/custom/Pagination.vue";
// end import loading overlay

export interface MasterRekening {
  _id?: string;
  price_title: string;
  description: string;
  price_type: string;
  price: number;
  tax: number;
  features: any[];
  billing_setting: BillingSetting;
  is_active: string | boolean;
}

export interface BillingSetting {
  billed: string;
  billing_day: number;
  billing_duration: number;
}

export default defineComponent({
  name: "MasterPricing",
  components: {
    Switch,
    Loading,
    Pagination,
  },
  props: {
    widgetClasses: String,
  },

  data() {
    return {
      // loading overlay setting
      isLoading: false,
      fullPage: true,
      isColor: "#007BFF",
      isBackgroundColor: "#A3A3A3",
      isOpacity: 0.5,
      // end loading overlay setting

      tableData: [] as MasterRekening[],
      paging: {
        page: 1,
        totalPages: 0,
        size: 10,
        totalElements: 0,
        perPageOptions: [10, 25, 50, 100],
      },
      maxVisiblePages: 5,
      name: "",
      showFilter: false,
      timer: 0,
    };
  },

  beforeMount() {
    this.getData(this.paging.size, this.paging.page);
  },

  computed: {
    to() {
      let highBound = this.from + this.paging.size;
      if (this.paging.totalElements < highBound) {
        highBound = this.paging.totalElements;
      }
      return highBound;
    },
    from() {
      return this.paging.size * this.paging.page;
    },
    visiblePages() {
      const currentPage = this.paging.page + 1;
      const totalPages = this.paging.totalPages;
      const maxVisible = this.maxVisiblePages;

      // Jika total halaman lebih sedikit dari yang ingin ditampilkan, tampilkan semua
      if (totalPages <= maxVisible) {
        return Array.from({ length: totalPages }, (_, i) => i + 1);
      }

      // Hitung halaman awal dan akhir dari "jendela"
      let startPage = currentPage - Math.floor(maxVisible / 2);
      let endPage = currentPage + Math.floor(maxVisible / 2);

      // Koreksi jika jendela keluar dari batas awal (kurang dari 1)
      if (startPage < 1) {
        startPage = 1;
        endPage = maxVisible;
      }

      // Koreksi jika jendela keluar dari batas akhir (lebih dari totalPages)
      if (endPage > totalPages) {
        endPage = totalPages;
        startPage = totalPages - maxVisible + 1;
      }

      // Buat array nomor halaman dari startPage ke endPage
      const pages: Array<number> = [];
      for (let i = startPage; i <= endPage; i++) {
        pages.push(i);
      }

      return pages;
    },
  },

  methods: {
    getData(size, page) {
      this.isLoading = true;
      const toast = useToast();

      let search = "";
      if (this.name) {
        search = "feature_name=" + this.name + "&";
      } else {
        search;
      }

      ApiService.getWithoutSlug(
        "crmv2/main_feature/pricing-plans/all?" +
          "&" +
          "page=" +
          page +
          "&size=" +
          size
      )
        .then(({ data }) => {
          this.tableData = data.content;
          if (data.content.length) {
            this.tableData = data.content.map((item, index) => {
              return {
                ...item,
                is_active: item.is_active ? "Active" : "Inactive",
              };
            });
          }
          this.paging.page = data.page;
          this.paging.size = data.size;
          this.paging.totalElements = data.totalElements;
          this.paging.totalPages = data.totalPages;

          this.isLoading = false;
        })
        .catch((e) => {
          console.log(e);

          if (e.response.status == 401) {
            toast.error(e.response.data.detail);
            this.$router.push("/sign-in");
            this.isLoading = false;
          } else {
            toast.error(e.response.data.detail);
            this.isLoading = false;
          }
        });
    },

    handleDelete(index, item) {
      Swal.fire({
        title: "Apakah Anda Yakin ?",
        text: `Data yang telah dihapus tidak dapat dikembalikan !`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: "Ya, hapus !",
        cancelButtonText: "Batal",
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.deleteRow(item);
        }
      });
    },
    deleteRow(item) {
      const toast = useToast();

      ApiService.delete(
        `crmv2/main_feature/pricing-plans/${item._id}/permanent`
      )
        .then((res) => {
          toast.success("Hapus Berhasil");

          this.getData(this.paging.size, this.paging.page);
        })

        .catch((error) => {
          toast.error("Gagal Hapus");
        });
    },

    range(min, max) {
      const arr: any[] = [];
      for (let i = min; i <= max; i++) {
        arr.push(i);
      }
      return arr;
    },

    changePage(item) {
      const page = item - 1;
      this.getData(this.paging.size, page);
    },
    nextPage() {
      const page = this.paging.page + 1;
      this.getData(this.paging.size, page);
    },
    prevPage() {
      const page = this.paging.page - 1;
      this.getData(this.paging.size, page);
    },
    changePageSize() {
      const page = this.paging.page;
      this.getData(this.paging.size, page);
    },

    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },

    //event
    eventDelaySearch(e) {
      clearTimeout(this.timer); //this timer 0 - set 0 atau clear jika ada input lagi
      this.timer = setTimeout(() => {
        const page = this.paging.page;
        this.getData(this.paging.size, page);
      }, 1000);
    },
    showHideFilter() {
      this.showFilter = !this.showFilter;
    },
    async handleChangeSwitch(data: { val: string; index: number }) {
      const toast = useToast();
      const pricingPlan = this.tableData[data.index];
      const endpoint = `crmv2/main_feature/pricing-plans/${pricingPlan._id}`;
      try {
        this.isLoading = true;
        if (data.val === "Inactive") {
          await ApiService.delete(endpoint);
        } else {
          pricingPlan.is_active = true;
          await ApiService.putWithData(endpoint, pricingPlan);
        }

        toast.success("Status berhasil diubah");
        this.getData(this.paging.size, this.paging.page);
      } catch (error) {
        toast.error("Terjadi keasalahan, Status gagal diubah");
      } finally {
        this.isLoading = false;
      }
    },
  },
});
